import { ToggleButton as MuiToggleButton } from "@mui/material";
import { CheckIcon } from "@phosphor-icons/react";
import { type MouseEvent, type ReactNode } from "react";

const LIST_TOGGLE_BUTTON_SX = {
  border: "none",
  borderRadius: "0",
  textTransform: "unset",
  padding: "16px 8px",
  "&.Mui-selected": {
    backgroundColor: "transparent",
    color: "inherit",
  },
  // Keep this explicit override so selected+hover doesn't fall back to MUI's default selected hover color.
  "&.Mui-selected:hover": {
    backgroundColor: "var(--color-surface-neutral-soft)",
  },
  "&:hover": {
    backgroundColor: "var(--color-surface-neutral-soft)",
  },
};

export type ListToggleButtonProps = {
  selectionVariant?: "checkmark" | "radio";
  value: string;
  onChange?: (event: MouseEvent<HTMLElement>, value: string) => void;
  children: ReactNode;
  selected?: boolean;
};

export function ListToggleButton({
  value,
  onChange,
  selected,
  children,
  selectionVariant = "checkmark",
}: ListToggleButtonProps) {
  return (
    <MuiToggleButton
      onChange={onChange}
      selected={selected}
      value={value}
      sx={LIST_TOGGLE_BUTTON_SX}
    >
      <div className="flex w-full">
        <span className="inline-flex grow items-center gap-2 text-base font-medium text-text-primary">
          {children}
        </span>

        {selectionVariant === "checkmark" && selected && (
          <CheckIcon
            size={20}
            className="fill-text-interactive"
            weight="bold"
          />
        )}

        {selectionVariant === "radio" && (
          <div
            className="relative size-5 shrink-0 rounded-full border-2"
            style={{
              borderColor: selected
                ? "var(--color-surface-accent-stronger)"
                : "var(--color-stroke-neutral-medium)",
            }}
          >
            {selected && (
              <div
                className="absolute inset-[3px] rounded-full"
                style={{
                  backgroundColor: "var(--color-surface-accent-stronger)",
                }}
              />
            )}
          </div>
        )}
      </div>
    </MuiToggleButton>
  );
}
